import { render, staticRenderFns } from "./NewYear2026.vue?vue&type=template&id=2a56945a&scoped=true&"
import script from "./NewYear2026.vue?vue&type=script&lang=js&"
export * from "./NewYear2026.vue?vue&type=script&lang=js&"
import style0 from "./NewYear2026.vue?vue&type=style&index=0&id=2a56945a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56945a",
  null
  
)

export default component.exports